// extracted by mini-css-extract-plugin
export default {"container":"CustomizeVertexModal_container__PiXi0"};